import moment from "moment-jalaali";
import MultiDatePicker from "react-multi-date-picker"
import { createDatePickerConfig } from "../../../helpers/helpers";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { Checkbox } from "antd";

const FilterTickets = props => {

    const Dictionary = useSelector(state => state.VisualData.Dictionary);
    const LAN = useSelector(state => state.VisualData.LAN);
    
    const {
        Statuses,
        CreationTimeFrom,
        CreationTimeTo,
        ReserveId,
        notRead
    } = props.filters;

    const [reserveIdText, setReserveIdText] = useState(ReserveId || "");

    let dateFromRef = useRef(null);
    let dateToRef = useRef(null);

    useEffect(() => {
        let timeOut;
        if (reserveIdText) {
            timeOut = setTimeout(() => { props.updateFilters("ReserveId", reserveIdText) }, 700);
        }
        return (() => { clearTimeout(timeOut); })
    }, [reserveIdText]);

    const [isMobile, setMobile] = useState(false);

    const initialDatepicket = LAN === "IR" ? ({
        type: "persian",
        locale: "fa"
    }):({
        type: "gregorian",
        locale: "en"
    });
    const [datepicker, setDatepicker] = useState(initialDatepicket);



    let minCreationTimeTo = undefined;
    if (CreationTimeFrom) {
        minCreationTimeTo = moment(CreationTimeFrom).format(datepicker.type === 'persian' ? "jYYYY/jMM/jDD" : "YYYY/MM/DD")
    }

    useEffect(() => {
        if (window.innerWidth <= 767) {
            setMobile(true)
        }
    }, []);

    const toggleDatepicker = () => {

        if (LAN !== "IR") return;

        setDatepicker(prevState => {
            const isPersian = prevState.locale === "fa";
            return ({
                locale: isPersian ? "en" : "fa",
                type: isPersian ? "gregorian" : "persian"
            })
        })

    }
    const datepickerConfig = createDatePickerConfig(LAN, datepicker.locale, isMobile);

    return (
        <div className="float-row margin-bottom-half">

            <div className="col-small-12 col-medium-4 col-large-2">
                <div class="form-group">
                    <label class="form-label"> {Dictionary.FromDate} </label>

                    <MultiDatePicker
                        ref={dateFromRef}
                        fixMainPosition={process.env.REACT_APP_THEME === 'ITOURS_IR'}
                        calendarPosition={datepickerConfig.calendarPosition}
                        weekDays={datepickerConfig.weekDays}
                        digits={datepickerConfig.digits}
                        inputClass="multi-datepicker-input h-40"
                        className={datepickerConfig.className}
                        maxDate={datepicker.type === 'persian'
                            ? moment().format('jYYYY/jMM/jDD')
                            : moment().format('YYYY/MM/DD')
                        }
                        format={'YYYY-MM-DD'}
                        calendar={datepicker.type}
                        locale={datepicker.locale}
                        value={CreationTimeFrom ? datepicker.type === 'persian' ? moment(CreationTimeFrom).format('jYYYY/jMM/jDD') : moment(CreationTimeFrom).format('YYYY/MM/DD') : ""}
                        onFocusedDateChange={d => {
                            const e = d.toDate();
                            props.updateFilters("CreationTimeFrom", moment(e).format("YYYY-MM-DD"));
                        }}
                        placeholder={Dictionary.FromDate}
                    >
                        {isMobile && (
                            <div className="date-picker-title">
                                date-picker-title
                            </div>
                        )}
                        {LAN === 'IR' && (
                            <button
                                type="button"
                                className="button blue-btn small-btn margin-bottom-half margin-top-half fa-font"
                                onClick={toggleDatepicker}>
                                {datepicker.locale === 'fa' ? 'تقویم میلادی' : 'تقویم شمسی'}
                            </button>
                        )}
                        {isMobile && (
                            <button className={'close-datepicker-btn'} onClick={() => { dateFromRef.current?.closeCalendar() }}>
                                <span className={`itours-icon gray-close-icon icon-large`} />
                            </button>
                        )}
                    </MultiDatePicker>

                </div>
            </div>
            <div className="col-small-12 col-medium-4 col-large-2 form-group">

                <label class="form-label"> {Dictionary.ToDate} </label>

                <MultiDatePicker
                    ref={dateToRef}
                    fixMainPosition={process.env.REACT_APP_THEME === 'ITOURS_IR'}
                    calendarPosition={datepickerConfig.calendarPosition}
                    weekDays={datepickerConfig.weekDays}
                    digits={datepickerConfig.digits}
                    inputClass="multi-datepicker-input h-40"
                    className={datepickerConfig.className}
                    maxDate={datepicker.type === 'persian'
                        ? moment().format('jYYYY/jMM/jDD')
                        : moment().format('YYYY/MM/DD')
                    }
                    minDate={minCreationTimeTo}
                    format={'YYYY-MM-DD'}
                    calendar={datepicker.type}
                    locale={datepicker.locale}
                    value={CreationTimeTo ? datepicker.type === 'persian' ? moment(CreationTimeTo).format('jYYYY/jMM/jDD') : moment(CreationTimeTo).format('YYYY/MM/DD') : ""}
                    onFocusedDateChange={d => {
                        const e = d.toDate();
                        props.updateFilters("CreationTimeTo", moment(e).format("YYYY-MM-DD"));
                    }}
                    placeholder={Dictionary.ToDate}
                >
                    {isMobile && (
                        <div className="date-picker-title">
                            date-picker-title
                        </div>
                    )}
                    {LAN === 'IR' && (
                        <button
                            type="button"
                            className="button blue-btn small-btn margin-bottom-half margin-top-half fa-font"
                            onClick={toggleDatepicker}>
                            {datepicker.locale === 'fa' ? 'تقویم میلادی' : 'تقویم شمسی'}
                        </button>
                    )}
                    {isMobile && (
                        <button className={'close-datepicker-btn'} onClick={() => { dateToRef.current?.closeCalendar() }}>
                            <span className={`itours-icon gray-close-icon icon-large`} />
                        </button>
                    )}
                </MultiDatePicker>

            </div>

            <div className="col-small-12 col-medium-4 col-large-2 form-group">
                <label class="form-label"> {Dictionary.status} </label>
                <select
                    className="form-select"
                    onChange={e => { props.updateFilters("Statuses", e.target.value); }}
                >
                    {[
                        { value: "", title: Dictionary.all },
                        { value: "Open", title: "Open" },
                        { value: "InProgress", title: "InProgress" },
                        { value: "Answered", title: "Answered" },
                        { value: "Closed", title: "Closed" }
                    ].map(item => (
                        <option
                            key={item.title}
                            value={item.value}
                            selected={item.value === Statuses}
                        >
                            {item.title}
                        </option>
                    ))}
                </select>
            </div>
            <div className="col-small-12 col-medium-4 col-large-2 form-group">
                <label class="form-label"> {Dictionary.ReservationNumber} </label>
                <input
                    className="form-input full-width"
                    onChange={e => {
                        setReserveIdText(e.target.value)
                        if (!e.target.value) {
                            props.updateFilters("ReserveId", "");
                        }
                    }}
                    value={reserveIdText || ""}
                />
            </div>
            <div className="col-small-12 col-medium-4 col-large-2 form-group">
                <Checkbox
                    value={"unread"}
                    className="antd-custom-checkbox medium-align-with-labels"
                    onChange={e => {
                        props.updateFilters("notRead", e.target.checked)
                    }}
                    checked={notRead}
                >
                    {Dictionary.Unread}
                </Checkbox>
            </div>
            <div className="col-small-12 col-medium-4 col-large-2 text-end form-group">
                <button
                    type="button"
                    className="button grey-btn medium-align-with-labels h-40"
                    onClick={() => {
                        props.resetFilters();
                        setReserveIdText("");
                    }}
                >
                    {Dictionary.ResetFilters}
                </button>
            </div>

        </div>
    )
}

export default FilterTickets;